import { createFileRoute } from '@tanstack/react-router'

import AntauLayout from '@/layouts/themes/antau/layout'
import { ANTAU_STOREFRONT } from '@/common/storefront/storefront.config'

export const Route = createFileRoute('/_layout')({
  beforeLoad: () => ({ storefront: ANTAU_STOREFRONT }),
  component: AntauLayout,
})
